import styled, { css } from "styled-components";

export const Wrapper = styled.div`
  ${({ theme }) => css`
    width: 100%;
    margin-top: 1rem;
    box-shadow: 0px 1px 2px 2px rgba(0, 0, 0, 0.1);
    border-top-right-radius: 8px;
    border-top-left-radius: 8px;

    @media (min-width: 768px) {
      max-width: 380px;
    }
  `}
`;

export const About = styled.div`
  ${({ theme }) => css`
    padding: 1rem;
    background-color: ${theme.colors.ultraLightGray};
  `}
`;

export const HeaderManagement = styled.div`
  ${({ theme }) => css`
    display: flex;
    justify-content: space-between;
    align-items: center;

    svg {
      color: ${theme.colors.primary};
    }

    > h3 {
      color: ${theme.colors.primary};
      font-size: 1.125rem;
      margin: 0;
    }
  `}
`;

export const DescriptionManagement = styled.div`
  margin-top: 1rem;
`;

export const ListAnimals = styled.div`
  ${({ theme }) => css`
    box-shadow: 0px 1px 2px 2px rgba(0, 0, 0, 0.1);
    border-top-right-radius: 8px;
    border-top-left-radius: 8px;
    padding: 1rem;

    .ant-collapse-header {
      background-color: ${theme.colors.white};
      border: 1px solid ${theme.colors.ultraLightGray};
    }

    .ant-collapse-icon-position-end
      > .ant-collapse-item
      > .ant-collapse-header
      .ant-collapse-arrow {
      top: 25%;
    }
  `}
`;

export const ItemDescription = styled.div`
  ${({ theme }) => css`
    display: flex;
    justify-content: space-between;

    & + div {
      margin-top: 0.5rem;
    }

    p {
      margin: 0;
      width: 120px;
      color: ${theme.colors.black};
      font-size: 0.875rem;
      opacity: 50%;
    }

    span {
      display: flex;
      align-items: center;
      justify-content: flex-end;
      font-size: 0.75rem;
      flex: 1;
      color: ${theme.colors.black};
    }
  `}
`;

export const HeaderCountAnimals = styled.div`
  ${({ theme }) => css`
    display: flex;
    justify-content: space-between;
    align-items: center;
    color: ${theme.colors.primary};
    font-size: 1.125rem;
    margin-bottom: 1rem;

    > h3 {
      color: ${theme.colors.primary};
      font-size: 1.125rem;
      margin: 0;
    }

    span {
      height: 20px;
      width: 20px;
      border-radius: 50%;
      background-color: ${theme.colors.primary};
      color: ${theme.colors.white};
      display: flex;
      align-items: center;
      justify-content: center;
      margin: 0;
      font-size: 0.875rem;
    }
  `}
`;

export const RemoveAnimal = styled.button`
  ${({ theme }) => css`
    width: 100%;
    display: flex;
    justify-content: flex-end;
    border: 0;
    background-color: transparent;
    margin-top: 1rem;
    font-size: 0.875rem;
    color: ${theme.colors.primary};
    text-decoration: underline;
  `}
`;

export const DescribeItemPanel = styled.div`
  ${({ theme }) => css`
    display: flex;

    & + div {
      margin-top: 0.5rem;
    }

    p {
      margin: 0;
      width: 140px;
      color: ${theme.colors.black};
      font-size: 0.875rem;
      opacity: 50%;
    }

    span {
      display: flex;
      align-items: center;
      justify-content: flex-end;
      font-size: 0.75rem;
      flex: 1;
      color: ${theme.colors.black};
    }
  `}
`;

export const EditAnimals = styled.div`
  padding: 1rem 0;
  max-height: calc(100vh - 550px);
  overflow-y: auto;
`;

export const ContentCards = styled.div`
  margin-top: 0rem;
  flex: 1;
`;

export const ContentAnimals = styled.div``;

export const ContentButton = styled.div`
  display: flex;
  justify-content: center;
  margin-top: 1rem;

  > button {
    width: 220px;
  }
`;

export const ManagementAnimals = styled.div`
  margin-top: 1.5rem;
  display: flex;
  justify-content: center;
`;
